/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_S2_TitleInputs */

const en_landing_how_s2_title = /** @type {(inputs: Landing_How_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paint it`)
};

const zh_landing_how_s2_title = /** @type {(inputs: Landing_How_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`涂区域`)
};

/**
* | output |
* | --- |
* | "Paint it" |
*
* @param {Landing_How_S2_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_how_s2_title = /** @type {((inputs?: Landing_How_S2_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_S2_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_how_s2_title(inputs)
	return zh_landing_how_s2_title(inputs)
});
export { landing_how_s2_title as "landing.how.s2_title" }